<template>
<div>
<v-text-field
  name="client-search"
  label="Search"
  :hint="hintText"
  @keypress.enter="searchClients(searchString)"
  @keydown.esc="searchString=''"
  @click:prepend='newClient'
  v-model='searchString'
  append-icon='search'
  :prepend-icon='prependIcon'
  :loading='clientsRequest.loading'
  browser-autocomplete='off'
  box clearable autofocus
  id="client-search" >
</v-text-field>
<div v-if='spaceName' class='caption px-2 blue lighten-4' type='info' >
  <v-icon small >info</v-icon>
  Only showing clients in <i>{{spaceName}}</i>
  <i v-if="includeOwnedByMe" > or owned by me</i>
</div>
<!-- <v-chip outline small :close="canClearSpace"
  v-if='spaceName'
  @input='$emit("update:spaceId", null)'  >
  <v-icon small left >filter_list</v-icon>
  {{spaceName}}</v-chip>

<v-chip outline small v-if='includeOwnedByMe' >
  <v-icon left small >add</v-icon> My clients
</v-chip> -->
<transition name='fade' >
  <!-- <pre v-text='$store.getters.clientsInRange' ></pre> -->
  <div v-if='withClientsInRange && (!searchString || searchString.length === 0)' >
    <v-subheader class='overline pl-1 my-0'>
      People you've seen in this period
      <v-spacer></v-spacer>
    </v-subheader>
    <v-checkbox v-if='withNotInvoicedFilter'
      v-model='showOnlyNotInvoiced'
      label='show only people who have not been invoiced' class='ma-0 pa-0' >
    </v-checkbox>
    <!-- <v-menu >
      <template v-slot:activator="{ on }">
        <v-subheader slot='activator' v-on='on' class='overline pl-0'>
          <v-btn small icon >
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
          People you've seen in this period
          <v-spacer></v-spacer>
        </v-subheader>
      </template>
      <v-list dense >
        <v-list-tile v-for='view in views' :key='view.title' >
          <v-list-tile-content>
            <v-list-tile-title v-text='view.title' >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu> -->
    <!-- $store.getters.clientsInRange.clients -->
    <v-chip small label
      v-for='(clientId, index) in quicklist'
      @click='clientSelected(getRelationByClientId(clientId))'
      :key='`chip-${clientId}-${index}`' >
      {{formatFullName(getClientById(clientId))}}
    </v-chip>
    <v-subheader v-if='showList' class='overline pl-1 my-0'>
      Other contacts
      <v-spacer></v-spacer>
    </v-subheader>
  </div>
</transition>
<transition name='fade' >
<v-list dense v-show='showList' >
  <template v-for='(client, index) in filteredClients' >
    <client-list-item
      :key='`cli-${client.id}-${index}`'
      :client='client.client'
      :relationship-id='client.id'
      :owner='client.practitioner'
      :spaces='client.spaces'
      :with-details='false'
      :with-action='withAction'
      :with-whats-app='withWhatsApp'
      @listitem:clicked='clientSelected(client)'
      :class='{ "blue lighten-5": (selected && selected.id === client.id) }' >
    </client-list-item>
    <v-divider :key='`div-${client.id}-${index}`' ></v-divider>
  </template>
    <v-list-tile v-if='limit <= filteredClients.length' >
      <v-list-tile-content >
          <v-btn @click='limit = limit + page' block flat >load more</v-btn>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider></v-divider>
    <v-card v-if='searchString && searchString.length > 0' flat>
      <v-alert dismissible type='warning' :value='spaceName && filteredClients.length === 0' class='amber py-1' >
        Only showing clients shared with {{spaceName}}.
        If you cannot find a specific client, you may need to share them with this space
      </v-alert>
      <v-card-actions>
        {{ Math.min(limit, filteredClients.length) }} results found
        <v-spacer></v-spacer>
        <v-btn outline small
          :loading='searchRequest.loading'
          @click='searchClients(searchString)' flat >Continue search on server</v-btn>
        <v-btn
          v-if='withCreate'
          @click='newClient'
          color='primary' small outline outlined >
          <v-icon class='mr-2' >person_add</v-icon>
          New
        </v-btn>
        <v-btn
          @click='getClients(1, pageSize)'
          :loading="clientsRequest.loading" flat >
          <v-icon>replay</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else flat>
      <v-card-actions>
        Showing {{Math.min(limit, clients.length)}} of {{clients.length}}
        <v-spacer></v-spacer>
        <v-btn @click='getClients(1, pageSize)' :loading="clientsRequest.loading" flat >
          <v-icon>replay</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
</v-list>
</transition>
</div>
</template>

<script>
import { LIST_CLIENTS_REQ, SEARCH_CLIENTS_REQ, CLIENT_PAGE_SIZE, CLIENT_ACTIVE_LIMIT } from '@/store/constants'
import ClientListItem from '@/components/client/ClientListItem'
import {mapGetters} from 'vuex'

export default {
  name: 'ClientList',
  components: {ClientListItem},
  props: {
    initialText: {type: String},
    showListInitially: { type: Boolean, default: true },
    withClientsInRange: { type: Boolean, default: false },
    withNotInvoicedFilter: { type: Boolean, default: true },
    withCreate: { type: Boolean, default: true },
    withWhatsApp: { type: Boolean, default: false },
    withAction: { type: Boolean, default: false },
    canClearSpace: { type: Boolean, default: true },
    includeOwnedByMe: { type: Boolean, default: true },
    spaceId: { required: false, description: 'Only show clients owned by me, or shared in provided space' },
    clearOnSelect: { type: Boolean, default: true, description: 'Clean the options list when they select a client' },
    touch: { type: Number, default: 10 }
  },
  data () {
    return {
      selected: {},
      searchString: '',
      debouncedSearchString: '',
      timeout: null,
      limit: 10,
      page: 10,
      hideList: false,
      showOnlyNotInvoiced: true,
      pageSize: CLIENT_PAGE_SIZE,
      clientLimit: CLIENT_ACTIVE_LIMIT,
      views: [
        { title: 'With appointments' },
        { title: 'With invoiceable appointments' }
      ]
    }
  },
  mounted () {
    if (this.initialText) {
      this.searchString = this.initialText
    }
  },
  methods: {
    clientSelected (client) {
      this.$emit('relationshipselected', client)
      let user = client.client
      this.$emit('clientselected', user)
      if (this.clearOnSelect && user) {
        this.searchString = user.first_name + ' ' + user.last_name
      }
      this.selected = client
      let vm = this
      setTimeout(() => {
        if (vm.clearOnSelect) {
          vm.hideList = true
        }
      }, 100)
    },
    newClient () {
      this.$emit('componentchanged', 'ClientCreate')
    }
    // searchClients (searchString) {
    //   let params = {
    //     'search': searchString
    //   }
    //   this.$appointmentguru
    //     .resource('practitioner.clients')
    //     .id(LIST_CLIENTS_REQ)
    //     .list(params)
    // }
  },
  computed: {
    ...mapGetters(['getSpaceById']),
    prependIcon () {
      if (this.withCreate === true) {
        return 'person_add'
      }
      return ''
    },
    hintText () {
      if (this.searchString && this.filteredClients.length === 0) {
        return 'Press enter to continue search on the server'
      }
      return 'Search on name, email, phone, nickname or custom_id'
    },
    showList () {
      if (this.hideList === true) { return false }
      if (!this.showListInitially) {
        return (this.searchString && this.searchString.length > 0)
      }
      return true
    },
    spaceName () {
      if (this.spaceId) {
        let space = this.getSpaceById(this.spaceId)
        if (space && space.title) { return space.title }
      }
    },
    clients () {
      return this.$store.getters.clients
    },
    clientsRequest () {
      return this.$store.getters.getRequestById(LIST_CLIENTS_REQ, true)
    },
    searchRequest () {
      return this.$store.getters.getRequestById(SEARCH_CLIENTS_REQ, true)
    },
    clientsRequestStatus () {
      return this.clientsRequest.status
    },
    filteredClients () {
      let clients = this.clients
      let meId = this.meId
      // let search = this.searchString
      if (this.spaceId) {
        clients = clients.filter((rel) => {
          if (this.includeOwnedByMe) {
            let ownedByMe = (parseInt(rel.practitioner) === meId)
            if (ownedByMe) { return true }
          }
          let spaceId = parseInt(this.spaceId)
          return rel.spaces.indexOf(spaceId) >= 0
        })
      }

      let search = this.debouncedSearchString
      if (search && search.length > 0) {
        clients = clients.filter((clientRel) => {
          if (clientRel.client) {
            let client = clientRel.client
            let index = `${clientRel.id} ${client.id} ${client.first_name} ${client.last_name} ${client.email} ${client.phone_number} ${client.custom_id} ${client.nickname}`
            return (index.toLowerCase()).indexOf(search.toLowerCase()) !== -1
          }
        })
      }
      return clients.slice(0, this.limit)
    },
    quicklist () {
      let clients = this.$store.getters.clientsInRange.clients
      let apptLookup = this.$store.getters.clientsInRange.appointmentsByClient
      if (this.showOnlyNotInvoiced) {
        clients = clients.filter((clientId) => {
          let appts = apptLookup[clientId]
          let statusCount = appts.filter((appt) => {
            return ['N', 'C'].indexOf(appt.status) >= 0
          }).length
          if (statusCount > 0) { return clientId }
        })
      }
      return clients
    }
  },
  watch: {
    touch () {
      this.searchString = ''
    },
    searchString () {
      this.hideList = false

      if (this.timeout) { window.clearTimeout(this.timeout) }
      let vm = this
      this.timeout = window.setTimeout(() => {
        vm.debouncedSearchString = vm.searchString
      }, 500)
    },
    initialText () {
      if (this.initialText) {
        this.searchString = this.initialText
      }
    },
    clientsRequestStatus () {
      if (this.clientsRequestStatus === 200) {
        this.$store.commit('addManyClients', this.clientsRequest.results)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientList.vue?2417b855